// Func = limiting Scope for this file
var lastScrollTop = 0;
const isHeaderTopPages = ( document.querySelector('#attractions, #gallery, .sitemap') !== null );
const scrollTriggerPoint = isHeaderTopPages ? -1 : 30;

(function(){

	$(document).ready(function () {

		// WRAP MODULE TABLES
		document.querySelectorAll('.tableModule table').forEach(table => {
			const tableWrapper = document.createElement('div');
			tableWrapper.classList.add('tableModule_wrap');
			table.parentNode.insertBefore(tableWrapper, table);
			tableWrapper.appendChild(table);
		});

		// NAV TOGGLE
		document.querySelectorAll('.js-headerNav_toggle').forEach(btn => {
			btn.addEventListener('click', e => {
				let navModule = document.querySelector(e.currentTarget.getAttribute('href'));
				e.preventDefault();
				navModule.classList.toggle('active');

				// Close Booking module
				document.getElementById('headerBooking').classList.remove('active');
				document.querySelectorAll('.js-headerBooking_toggle').forEach(btn => btn.classList.remove('active') );
			});
		});

		// BOOKING TOGGLE
		document.querySelectorAll('.js-headerBooking_toggle').forEach(btn => {
			btn.addEventListener('click', e => {
				let bookingModule = document.querySelector(e.currentTarget.getAttribute('href'));

				e.preventDefault();
				if(bookingModule.classList.contains('fixed')){
					bookingModule.classList.toggle('active');
					e.currentTarget.classList.toggle('active');
				} else{
					$('html,body').stop().animate({ scrollTop: bookingModule.offsetTop - document.querySelector('.headerBooking_wrapper').offsetHeight }, 500, function(){
						document.querySelector('.header').classList.remove('up');
						document.querySelector('.header').classList.add('down');
					});
				}

				// Close Nav module
				document.getElementById('headerNav').classList.remove('active');
				document.querySelectorAll('.js-headerNav_toggle').forEach(btn => btn.classList.remove('active') );
			});
		});


		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){
			let d1=$.datepicker.parseDate(visible_format,$('#CheckIn').val());
			let d2=$.datepicker.parseDate(visible_format,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn--alt").data("format") !== undefined && $("#CheckIn--alt").data("format")) ? $("#CheckIn--alt").data("format") : "mm/dd/yy";
		const visible_format = 'M dd, yy';
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: visible_format,
            numberOfMonths: 1,
			minDate: 0,
			altField: '#CheckIn--alt',
			altFormat: DATE_FORMAT,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: visible_format,
            changeMonth: true,
			numberOfMonths: 1,
			altField: '#CheckOut--alt',
			altFormat: DATE_FORMAT,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// INITIAL DATES
		let custom_todayDate = new Date();
		let custom_addedDate = () => {
			let newDate = new Date();
			newDate.setDate(custom_todayDate.getDate() + 3);
			return newDate;
		};
		$( "#CheckIn" ).datepicker( "setDate" , custom_todayDate );
		$( "#CheckOut" ).datepicker( "setDate" , custom_addedDate() );
		$('.ui-datepicker').hide(); //Force datepicker to be hidden after setting initial dates

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/
		scrollDownAction(scrollTriggerPoint, 'scroll');
		if ( isHeaderTopPages ) window.scrollTo(0,1);

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	const headerSelector = document.getElementById('header');
	if(st > 30){
		if (st > lastScrollTop){
			// downscroll code
			if(!headerSelector.classList.contains('down')){
				headerSelector.classList.add('down');
				headerSelector.classList.remove('up');
			}
		} else {
			// upscroll code
			if(!headerSelector.classList.contains('up')){
				headerSelector.classList.add('up');
				headerSelector.classList.remove('down');
			}
		}
	} else {
		if(headerSelector.classList.contains('up') || headerSelector.classList.contains('down')){
			headerSelector.classList.remove('up');
			headerSelector.classList.remove('down');
		}
	}

	for(let el of document.getElementsByClassName('headerBooking')) {
		const homepageOffset = document.getElementById('home') ? 0 : document.querySelector('.header').offsetHeight;
		if(st > 30){
			if ( st > el.offsetTop - homepageOffset ) {
				el.classList.add('fixed');
				if (st > lastScrollTop){
					el.classList.add('down');
					el.classList.remove('up');
				} else{
					el.classList.add('up');
					el.classList.remove('down');
				}
			} else {
				el.classList.remove('fixed');
				el.classList.remove('up');
				el.classList.remove('down');
			}
			el.classList.remove('bookingTop');
		} else{
			el.classList.add('bookingTop');
		}
		el.classList.remove('active');
	}

	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}